import { REACT_APP_INFURA_ID } from "../utils/env";
const ETH = {
  name: "Ether",
  symbol: "ETH",
  decimals: 18,
};

const MATIC = {
  name: "Matic",
  symbol: "MATIC",
  decimals: 18,
};

function isExtendedChainInformation(chainInformation) {
  return !!chainInformation.nativeCurrency;
}

export function getAddChainParameters(chainId) {
  const chainInformation = CHAINS[chainId];
  if (isExtendedChainInformation(chainInformation)) {
    return {
      chainId,
      chainName: chainInformation.name,
      nativeCurrency: chainInformation.nativeCurrency,
      rpcUrls: chainInformation.urls,
      blockExplorerUrls: chainInformation.blockExplorerUrls,
    };
  } else {
    return chainId;
  }
}
export const CHAINS = {
  1: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://mainnet.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
      process.env.alchemyKey
        ? `https://eth-mainnet.alchemyapi.io/v2/${process.env.alchemyKey}`
        : undefined,
      "https://cloudflare-eth.com",
    ].filter((url) => url !== undefined),
    name: "Mainnet",
  },
  3: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://ropsten.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
    ].filter((url) => url !== undefined),
    name: "Ropsten",
  },
  4: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://rinkeby.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
    ].filter((url) => url !== undefined),
    name: "Rinkeby",
  },
  5: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://goerli.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
    ].filter((url) => url !== undefined),
    name: "Görli",
  },
  42: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://kovan.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
    ].filter((url) => url !== undefined),
    name: "Kovan",
  },
  // Optimism
  10: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://optimism-mainnet.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
      "https://mainnet.optimism.io",
    ].filter((url) => url !== undefined),
    name: "Optimism",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://optimistic.etherscan.io"],
  },
  69: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://optimism-kovan.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
      "https://kovan.optimism.io",
    ].filter((url) => url !== undefined),
    name: "Optimism Kovan",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://kovan-optimistic.etherscan.io"],
  },
  // Arbitrum
  42161: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://arbitrum-mainnet.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
      "https://arb1.arbitrum.io/rpc",
    ].filter((url) => url !== undefined),
    name: "Arbitrum One",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://arbiscan.io"],
  },
  421611: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://arbitrum-rinkeby.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
      "https://rinkeby.arbitrum.io/rpc",
    ].filter((url) => url !== undefined),
    name: "Arbitrum Testnet",
    nativeCurrency: ETH,
    blockExplorerUrls: ["https://testnet.arbiscan.io"],
  },
  // Polygon
  137: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://polygon-mainnet.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
      "https://polygon-rpc.com",
    ].filter((url) => url !== undefined),
    name: "Polygon Mainnet",
    nativeCurrency: MATIC,
    blockExplorerUrls: ["https://polygonscan.com"],
  },
  80001: {
    urls: [
      REACT_APP_INFURA_ID
        ? `https://polygon-mumbai.infura.io/v3/${REACT_APP_INFURA_ID}`
        : undefined,
    ].filter((url) => url !== undefined),
    name: "Polygon Mumbai",
    nativeCurrency: MATIC,
    blockExplorerUrls: ["https://mumbai.polygonscan.com"],
  },
};

export const URLS = Object.keys(CHAINS).reduce((accumulator, chainId) => {
  const validURLs = CHAINS[Number(chainId)].urls;

  if (validURLs.length) {
    accumulator[Number(chainId)] = validURLs;
  }

  return accumulator;
}, {});
